import { Component, OnInit } from '@angular/core';
import { ReportDesignerService } from '../../../services/report-designer.service';
import { EventBusService } from '../../../../../services/event-bus.service';
import { templatesGridColumns } from './delete-template-grid-config';
import { PolluxGridConfig } from '../../../../../components/common/pollux-grid-config/pollux-grid-config';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { DateUtil } from '../../../../../components/common/date-util/date-util';

/**
 * Delete template dialog component
 */
@Component({
  selector: 'delete-template-dialog',
  templateUrl: './delete-template-dialog.component.html',
  styleUrls: ['./delete-template-dialog.component.scss']
})
export class DeleteTemplateDialogComponent implements OnInit {

  /**
   * Indicator is the dialog openet
   */
  public isDialogOpened = false;

  /**
   * All available templates
   */
  public templates: any[] = [];

  /**
   * All available localization
   */
  availableLanguages: any[] = [];

  /**
   * Selected template
   */
  selectedTemplate: any = null;

  /**
   * Dialog title
   */
  title = 'DELETE TEMPLATE';

  /**
   * Flag for delete button
   */
  enableDelete = false;

  /**
   * Constructor
   * @param eventBus
   * @param _reportService
   */
  constructor(private eventBus: EventBusService,
    private _reportService: ReportDesignerService) {
  }

  /**
   * Initializes the component
   */
  public ngOnInit(): void {
    this.eventBus.subscribeEvent('deleteTemplate', (data, _options) => {
      if (!this.isDialogOpened) {
        this.isDialogOpened = true;
        this.availableLanguages = data.allReportDesignerLocales;
        this.loadTemplates();
      }
    });
  }

  /**
   * Selectable settings
   */
  public selectableSettings: SelectableSettings = {
    checkboxOnly: false,
    mode: 'single',
    drag: false,
  };

  /**
   * Reset all data to default values
   */
  private reset(): void {
    this.isDialogOpened = false;
    this.enableDelete = false;
  }

  /**
   * On cancel action
   */
  public cancel(): void {
    this.reset();
  }

  /**
   * Gets the columns
   */
  public get columns(): PolluxGridConfig[] {
    return templatesGridColumns;
  }

  /**
   * On select grid row
   */
  public onSelect(item: any): void {
    this.selectedTemplate = item.selectedRows[0].dataItem.Oid;
    this.enableDelete = true;
  }

  /**
   * Delete template event
   */
  public deleteTemplate(): void {
    this._reportService.deleteTemplate(this.selectedTemplate).subscribe(data => {
      this.reset();
      this.handleTemplateDeleted(data.m_Item1);
    });
  }

  /**
   * Load the templates
   */
  private loadTemplates(): void {
    this._reportService.templateWithoutJson().subscribe(data => {
      if (data) {
        this.templates = data.filter(item => item.InvisibleFlag != 1);
        this.parseDatesOnLoad(this.templates);
      }
    });
  }


  /**
   * Important: All date values are treated as UTC dates in the backend.
   * Therefore, please parse all date values into a Date by using this.getDate within this method.
   * This step occurs directly before the createFormGroup step
   * @param data The loaded and post-processed data
   */
  protected parseDatesOnLoad(data: any[]): void {
    if (data?.length) {
      for (const field of this.columns) {
        if (field.type === 'date') {
          for (const row of data) {
            row[field.field] = DateUtil.getDate(row[field.field]);
          }
        }
      }
    }
  }

  /**
   * Handle dialog open after template is deleted
   */
  private handleTemplateDeleted(item: any): void {
    if (item) {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'reportDesignerDialogDeleteTemplateSuccessfully');
    } else {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'reportDesignerDialogDeleteTemplateFailed');
    }
  }
}
